import { render, staticRenderFns } from "./SportUpdateForm.vue?vue&type=template&id=dafe1d7e&"
import script from "./SportUpdateForm.vue?vue&type=script&lang=js&"
export * from "./SportUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dafe1d7e')) {
      api.createRecord('dafe1d7e', component.options)
    } else {
      api.reload('dafe1d7e', component.options)
    }
    module.hot.accept("./SportUpdateForm.vue?vue&type=template&id=dafe1d7e&", function () {
      api.rerender('dafe1d7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SportUpdateForm.vue"
export default component.exports